var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 24 24",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75,17.375L20.75,6.625C20.75,5.108 19.518,3.875 18,3.875L6,3.875C4.482,3.875 3.25,5.108 3.25,6.625C3.25,6.625 3.25,17.375 3.25,17.375C3.25,17.603 3.278,17.824 3.33,18.036C3.591,19.093 4.464,19.91 5.551,20.088C5.697,20.113 5.847,20.125 6,20.125C6,20.125 18,20.125 18,20.125C18.153,20.125 18.303,20.113 18.449,20.088C19.536,19.91 20.409,19.093 20.67,18.036C20.722,17.824 20.75,17.603 20.75,17.375ZM19.25,14.375C18.255,14.375 14.639,14.375 14.639,14.375C14.426,15.189 13.806,16.375 12,16.375C10.194,16.375 9.574,15.189 9.361,14.375L4.75,14.375L4.75,17.375C4.75,17.665 4.849,17.932 5.015,18.144C5.244,18.437 5.6,18.625 6,18.625L18,18.625C18.4,18.625 18.756,18.437 18.985,18.144C19.151,17.932 19.25,17.665 19.25,17.375L19.25,14.375ZM19.25,12.625C19.25,11.935 18.69,11.375 18,11.375L6,11.375C5.31,11.375 4.75,11.935 4.75,12.625L4.75,12.875L10,12.875C10.414,12.875 10.75,13.211 10.75,13.625C10.75,13.625 10.75,14.875 12,14.875C13.25,14.875 13.25,13.625 13.25,13.625C13.25,13.211 13.586,12.875 14,12.875L19.25,12.875L19.25,12.625ZM19.25,9.625C19.25,8.935 18.69,8.375 18,8.375C18,8.375 6,8.375 6,8.375C5.31,8.375 4.75,8.935 4.75,9.625L4.75,10.175C5.125,9.983 5.55,9.875 6,9.875C6,9.875 18,9.875 18,9.875C18.45,9.875 18.875,9.983 19.25,10.175L19.25,9.625ZM19.25,7.175L19.25,6.625C19.25,5.935 18.69,5.375 18,5.375C18,5.375 6,5.375 6,5.375C5.31,5.375 4.75,5.935 4.75,6.625L4.75,7.175C5.125,6.983 5.55,6.875 6,6.875L18,6.875C18.45,6.875 18.875,6.983 19.25,7.175Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.134f1679.svg";
export { ForwardRef as ReactComponent };